import { useMemo } from 'react'
import type { ShopI18nContextValue } from '../../../../i18n/provider/types'
import { EMAIL_REGEX } from '../../../hooks/customer-auth-form/validation.constants'
import type { ForgotPasswordFlowState, ForgotPasswordFieldErrors } from './ForgotPasswordFlow.types'

type Translate = ShopI18nContextValue['t']

type UseForgotPasswordViewModelInput = {
  state: ForgotPasswordFlowState
  t: Translate
}

type UseForgotPasswordViewModelOutput = {
  emailError: string
  fieldErrors: ForgotPasswordFieldErrors
  title: string
  subtitle: string
}

export const useForgotPasswordViewModel = ({
  state,
  t,
}: UseForgotPasswordViewModelInput): UseForgotPasswordViewModelOutput => {
  const emailError = useMemo(() => {
    if (!state.emailTouched) return ''
    const normalized = state.email.trim()
    if (!normalized) return t('customer.auth.validation.requiredField')
    if (!EMAIL_REGEX.test(normalized)) return t('customer.auth.validation.emailInvalid')
    return ''
  }, [state.email, state.emailTouched, t])

  const fieldErrors = useMemo<ForgotPasswordFieldErrors>(
    () => ({
      email: emailError,
    }),
    [emailError],
  )

  return {
    emailError,
    fieldErrors,
    title: state.success ? t('customer.auth.forgotPassword.successTitle') : t('customer.auth.forgotPassword.title'),
    subtitle: state.success
      ? t('customer.auth.forgotPassword.successBody')
      : t('customer.auth.forgotPassword.subtitle'),
  }
}
